import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService, VehicleAlertWebSocketService } from '../services';
import { LocalStorage } from '../enums';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private vehicleAlertWebSocketService: VehicleAlertWebSocketService
  ) { }

  canActivate() {
    if (this.localStorageService.getData(LocalStorage.accessToken)) {
      const loginData = JSON.parse(this.localStorageService.getData(LocalStorage.loginData));
      this.vehicleAlertWebSocketService.connect(loginData.user_id);
      return true;
    }
    this.vehicleAlertWebSocketService.disconnect();
    // this.router.navigate(['/' + Paths.authentication + '/' + Paths.login]);
    this.router.navigate(['/']); 
    localStorage.clear();
    return false;
  }
}
